import { render, staticRenderFns } from "./CustomerNavigation.vue?vue&type=template&id=cc52b194&scoped=true"
var script = {}
import style0 from "./CustomerNavigation.vue?vue&type=style&index=0&id=cc52b194&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc52b194",
  null
  
)

export default component.exports